
import CodeArea from "./CodeArea";
import Header from "./Header";
import Result from './Result';

const Home = () => {
    return (
        <>
            <Header></Header>
            <CodeArea></CodeArea>
            <Result />
        </>
    )
}

export default Home;
